import Link from 'next/link';
import { policies, piva } from '@/lib/data';

export default function Copyright() {
  const date = new Date();
  return (
    <div className="flex flex-col items-center gap-2">
      <p className="flex text-secondary/75 text-xs justify-center pt-2">
        Copyright © {date.getFullYear()}. Tutti i diritti riservati.
      </p>
      <span className="text-secondary/75 text-xs">P.IVA {piva}</span>
      <div className="flex flex-row gap-2 items-center">
        <Link
          className="text-cta-100/75 text-sm hover:underline"
          href={policies.cookies}>
          Informativa Cookies
        </Link>
        <div className="h-1 w-1 rounded-full bg-secondary/75" />
        <Link
          className="text-cta-100/75 text-sm hover:underline"
          href={policies.privacy}>
          Informativa Privacy
        </Link>
      </div>
    </div>
  );
}
